module.exports = {
  json_validation_error:
    'Формат файла не соответствует стандарту для импорта. Просим загрузить корректный файл. Подробнее о возможных проблемах с форматами фалов читайте в разделе “Помощь“.',
  cancel_button: 'Отмена',
  next_button: 'Далее',
  next_button_final: 'Импортировать файл',
  upload_label: 'Загрузите файл',
  alias_label: 'Настройка алиасов',
  dictionaries_label: 'Настройка словарей',
  additional_settings_label: 'Дополнительные настройки',
  channels: 'Каналы',
  c_roles: 'Роли',
  classifier2: 'Модель классификатора',
  gpt_integrations_user: 'Пользовательские GPT интеграции',
  gpt_integrations_system: 'Системные GPT интеграции',
  preset_settings: 'Настройки пресета',
  metrics_settings: 'Настройки метрик',
  reports_settings: 'Настройки отчетов',
  cancel: 'Отмена',
  download: 'Скачать',
};
